// 入庫

const LOADING_STATUS = {
  LOADING: 1,
  CANCEL: 99
}

export default {
  LOADING_STATUS
}
